export const SearchEntityIdTypes = {
	user: 'user',
	imUser: 'im-user',
	bot: 'im-bot',
	chat: 'im-chat',
	chatUser: 'im-chat-user',
	department: 'department',
	network: 'imbot-network',
	openLines: 'LINES',
};
